export default __webpack_public_path__ + "static/media/Pointstables.170eaa71.png";